import SiteSearchNarrow from "./site-search-narrow";


const siteSearchElements = document.querySelectorAll("[data-site-search]");
const siteSearchElementsArray = [...siteSearchElements];

siteSearchElementsArray.forEach(function(element) {
	const options = {
		openButton: document.querySelector(element.dataset.siteSearchOpenButtonSelector),
		field: element.querySelector(element.dataset.siteSearchFieldSelector),
		overlay: document.querySelector(element.dataset.siteSearchOverlaySelector),
		siteHeader: document.querySelector(element.dataset.siteSearchHeaderSelector),
	};

	const instance = new SiteSearchNarrow(element, options);
	element.instance = instance;
});




// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header-narrow/index.js